import { FC, useEffect, useState } from 'react'
import { Keyboard } from '@capacitor/keyboard'
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import { setPhotosQuery, useAppDispatch, useAppSelector } from '../../../../redux'
import { debounceFilter } from '../../../../utils'
import { StyledPhotosFilters } from '.'

const PhotosFilters: FC = () => {
  const dispatch = useAppDispatch()
  const { search } = useAppSelector((state) => state.photos)
  const [localSearch, setLocalSearch] = useState(search)

  // Sync local state when Redux state changes
  useEffect(() => {
    setLocalSearch(search)
  }, [search])

  const handleChange = (value: string) => {
    // Update local state immediately for visual feedback
    setLocalSearch(value)
    // Debounce the Redux dispatch
    debounceFilter(() => dispatch(setPhotosQuery(value)))
  }

  return (
    <StyledPhotosFilters>
      <div className="input-container">
        <MagnifyingGlassIcon />
        <input
          type="search"
          placeholder="Search photos"
          enterKeyHint="search"
          value={localSearch}
          onChange={(e) => handleChange(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && Keyboard.hide()}
        />
      </div>
      {/* <button className="filters-btn">
        <FunnelIcon />
      </button> */}
    </StyledPhotosFilters>
  )
}

export default PhotosFilters
